import Api from '../api'
export default ({
  state: {
    maxSalesOrderNumber: null,
    maxSalesChallanNumber: null,
    maxSalesInvoiceNumber: null,
    maxPurchaseReturnNumber: null,
    maxConsumptionNumber: null,
    maxDamageNumber: null,
    salesChallanLists: [],
    salesOrderLists: [],
    salesDeliveryPendingLists: [],
    salesOrderCompletedLists: [],
    stockTransforLists: [],
    salesInvoiceLists: [],
    salesInvoiceReversalLists: [],
    salesReturnLists: [],
    inventoryOutDetailList: [],
    deliveredLists: [],
    delivereyRequestLists: [],
    deliveryOrderLists: [],
    vendarDeliveryLists: [],
    vendarDeliveryPaidLists: [],
    vendarDeliveryUnPaidLists: [],
    pendingDeliveryLists: [],
    purchaseListForSales: [],
    deliveryRemarksLogLists: [],
    latestSalesRateLists: [],
    toBeVerifyDeliveryLists: [],
    variantDetailLists: [],
    monthlyTargetLists: [],
    salesInvoiceUnpaidLists: [],
    salesInvoiceChequeReceivedLists: [],
    salesInvoiceTodayUnpaidLists: [],
    profitGross: [],
    expensesReport: [],
    salesUnreceivedLists: [],
    salesUnreceivedAllLists: [],
    customerWiseSalesCountList: [],
    salesUnpaidAndPaidAllLists: [],
    salesUnpaidNextFollowUpBetween: [],
    salesTodysPaymentFollowUpLists: [],
    salesInvoicePaidLists: []
  },
  mutations: {
    ADD_MONTHLY_TARGET(state, monthlyTarget) {
      let monthlyTargetList = state.monthlyTargetLists.concat(monthlyTarget)
      state.monthlyTargetLists = monthlyTargetList
    },
    DELETE_MONTHLY_TARGET(state, targets) {
      let monthlyTargetList = state.monthlyTargetLists.filter(target => target.id !== targets.id)
      state.monthlyTargetLists = monthlyTargetList
    },
    SET_MONTHLY_TARGET_LIST(state, monthlyTargetList) {
      state.monthlyTargetLists = monthlyTargetList
    },
    UPDATE_MONTHLY_TARGET(state, monthlyTarget) {
      let monthlyTargetList = state.monthlyTargetLists.map(target => target.id !== monthlyTarget.id ? target : {...target, ...monthlyTarget})
      state.monthlyTargetLists = monthlyTargetList
    },
    MAX_SALES_ORDER_NUMBER(state, maxSalesOrderNo) {
      state.maxSalesOrderNumber = maxSalesOrderNo
    },
    MAX_CONSUMPTION_NUMBER(state, maxConsumptionNo) {
      state.maxConsumptionNumber = maxConsumptionNo
    },
    MAX_DAMAGE_NUMBER(state, maxDamageNo) {
      state.maxDamageNumber = maxDamageNo
    },
    MAX_SALES_CHALLAN_NUMBER(state, maxSalesChallanNo) {
      state.maxSalesChallanNumber = maxSalesChallanNo
    },
    MAX_SALES_INVOICE_NUMBER(state, maxSalesInvoiceNo) {
      state.maxSalesInvoiceNumber = maxSalesInvoiceNo
    },
    MAX_PURCHASE_RETURN_NUMBER(state, maxPurchaseReturnNo) {
      state.maxPurchaseReturnNumber = maxPurchaseReturnNo
    },
    SALES_CHALLAN_LIST(state, salesChallanList) {
      state.salesChallanLists = salesChallanList
    },
    PURCHASE_LIST_FOR_SALES(state, purchaseListForSale) {
      state.purchaseListForSales = purchaseListForSale
    },
    SALES_ORDER_LIST(state, salesOrderList) {
      state.salesOrderLists = salesOrderList
    },
    CONSUMPTION_LIST(state, consumptionList) {
      state.consumptionLists = consumptionList
    },
    DAMAGE_LIST(state, damageList) {
      state.damageLists = damageList
    },
    DELIVERY_ORDER_LIST(state, deliveryOrderList) {
      state.deliveryOrderLists = deliveryOrderList
    },
    DELIVERY_TO_VERIFY_LIST(state, toBeVerifyDeliveryList) {
      state.toBeVerifyDeliveryLists = toBeVerifyDeliveryList
    },
    VENDER_DELIVERY_LIST(state, vendorDeliveryList) {
      state.vendarDeliveryLists = vendorDeliveryList
    },
    PENDING_DELIVERY_LIST(state, pendingDeliveryList) {
      state.pendingDeliveryLists = pendingDeliveryList
    },
    VENDER_DELIVERY_PAID_LIST(state, vendarDeliveryPaidList) {
      state.vendarDeliveryPaidLists = vendarDeliveryPaidList
    },
    VENDER_DELIVERY_UNPAID_LIST(state, vendarDeliveryUnPaidList) {
      state.vendarDeliveryUnPaidLists = vendarDeliveryUnPaidList
    },
    DELIVERY_REMARKS_LOG_LIST(state, deliveryRemarksLogList) {
      state.deliveryRemarksLogLists = deliveryRemarksLogList
    },
    LATEST_SALES_RATE_LIST(state, latestSalesRateList) {
      state.latestSalesRateLists = latestSalesRateList
    },
    VARIANT_DETAILS_LIST(state, variantDetailList) {
      state.variantDetailLists = variantDetailList
    },
    DELIVERY_STATUS_UPDATE(state, updatedDelivery) {
      let deliveryOrderList = state.deliveryOrderLists.map(so => so.id !== updatedDelivery.id ? so : {...so, ...updatedDelivery})
      state.deliveryOrderLists = deliveryOrderList
    },
    DELIVERED_LIST(state, deliveredList) {
      state.deliveredLists = deliveredList
    },
    DELIVERY_REQUEST_LIST(state, delivereyRequestList) {
      state.delivereyRequestLists = delivereyRequestList
    },
    SALES_ORDER_COMPLETED_LIST(state, salesOrderCompletedList) {
      state.salesOrderCompletedLists = salesOrderCompletedList
    },
    SALES_DELIVERY_PENDING_LIST(state, salesDeliveryPendingList) {
      state.salesDeliveryPendingLists = salesDeliveryPendingList
    },
    SALES_INVOICE_LIST(state, salesInvoiceList) {
      state.salesInvoiceLists = salesInvoiceList
    },
    PROFIT_GROSS(state, profitGross) {
      state.profitGross = profitGross
    },
    EXPENSES_REPORT(state, expenses) {
      state.expensesReport = expenses
    },
    SALES_INVOICE_UNPAID_LIST(state, salesInvoiceUnpaidList) {
      state.salesInvoiceUnpaidLists = salesInvoiceUnpaidList
    },
    SALES_INVOICE_CHEQUERECEIVED_LIST(state, salesInvoiceChequeReceivedList) {
      state.salesInvoiceChequeReceivedLists = salesInvoiceChequeReceivedList
    },
    SALES_INVOICE_PAID_LIST(state, salesInvoicePaidList) {
      state.salesInvoicePaidLists = salesInvoicePaidList
    },
    SALES_INVOICE_TODAY_UNPAID_LIST(state, salesInvoiceTodayUnpaidList) {
      state.salesInvoiceTodayUnpaidLists = salesInvoiceTodayUnpaidList
    },
    SALES_INVOICE_UNRECEIVED_LIST(state, salesUnreceivedList) {
      state.salesUnreceivedLists = salesUnreceivedList
    },
    SALES_INVOICE_UNRECEIVED_ALL_LIST(state, salesUnreceivedList) {
      state.salesUnreceivedAllLists = salesUnreceivedList
    },
    SALES_INVOICE_UNPAID_NEXT_FOLLOWUP(state, salesUnpaidNextFollow) {
      state.salesUnpaidNextFollowUpBetween = salesUnpaidNextFollow
    },
    SALES_PAYMENT_TODAYS_FOLLOWUP(state, salesPaymentTodayFollowUp) {
      state.salesTodysPaymentFollowUpLists = salesPaymentTodayFollowUp
    },
    SALES_INVOICE_UNPAID_AND_PAID_ALL_LIST(state, salesUnreceivedList) {
      state.salesUnpaidAndPaidAllLists = salesUnreceivedList
    },
    CUSTOMER_WISE_SALES_COUNT_LIST(state, customerWiseSalesCount) {
      state.customerWiseSalesCountList = customerWiseSalesCount
    },
    SALES_INVOICE_VOID_LIST(state, salesInvoiceVoidList) {
      state.salesInvoiceVoidLists = salesInvoiceVoidList
    },
    STOCK_TRANSFOR_LIST(state, stockTransforList) {
      state.stockTransforLists = stockTransforList
    },
    DELETE_SALES_ORDER (state, salesOrder) {
      let inventoryOutHeader = state.salesOrderLists.filter(a => a.id !== salesOrder.id)
      state.salesOrderLists = inventoryOutHeader
    },
    DELETE_STOCK_TRANSFOR (state, stockTransfor) {
      let stockTransforId = state.stockTransforLists.filter(a => a.id !== stockTransfor.id)
      state.stockTransforLists = stockTransforId
    },
    DELETE_SALES_CHALLAN(state, salesChallan) {
      let salesChallanList = state.salesChallanLists.filter(a => a.id !== salesChallan.id)
      state.salesChallanLists = salesChallanList
    },
    DELETE_SALES_INVOICE(state, salesInvoice) {
      let salesInvoiceList = state.salesInvoiceLists.filter(a => a.id !== salesInvoice.id)
      state.salesInvoiceLists = salesInvoiceList
    },
    DELETE_SALES_RETURN(state, salesReturn) {
      let salesReturnList = state.salesReturnLists.filter(a => a.id !== salesReturn.id)
      state.salesReturnLists = salesReturnList
    },
    UPDATE_SALES_ORDER(state, salesOrder) {
      let salesOrderList = state.salesOrderLists.map(so => so.id !== salesOrder.id ? so : {...so, ...salesOrder})
      state.salesOrderLists = salesOrderList
    },
    UPDATE_CONSUMPTION(state, consumption) {
      let consumptionList = state.consumptionLists.map(so => so.id !== consumption.id ? so : {...so, ...consumption})
      state.consumptionLists = consumptionList
    },
    UPDATE_DAMAGE(state, damage) {
      let damageList = state.damageLists.map(so => so.id !== damage.id ? so : {...so, ...damage})
      state.damageLists = damageList
    },
    UPDATE_SALES_INVOICE(state, salesInvoice) {
      let salesInvoiceList = state.salesInvoiceLists.map(salesInv => salesInv.id !== salesInvoice.id ? salesInv : {...salesInv, ...salesInvoice})
      state.salesInvoiceLists = salesInvoiceList
    },
    UPDATE_SALES_RETURN(state, salesReturn) {
      let salesReturnList = state.salesReturnLists.map(salesRet => salesRet.id !== salesReturn.id ? salesRet : {...salesRet, ...salesReturn})
      state.salesReturnLists = salesReturnList
    },
    UPDATE_SALES_CHALLAN(state, salesChallan) {
      let salesChallanList = state.salesChallanLists.map(salesChal => salesChal.id !== salesChallan.id ? salesChal : {...salesChal, ...salesChallan})
      state.salesChallanLists = salesChallanList
    },
    INVENTORY_OUT_DETAIL(state, inventoryOutDetail) {
      state.inventoryOutDetailList = inventoryOutDetail
    },
    SALES_RETURN_LIST(state, salesReturnList) {
      state.salesReturnLists = salesReturnList
    }
  },
  actions: {
    async maxSalesOrderNo({ commit }) {
      let response = await Api.request('get', '/inventoryOut/salesOrderLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_SALES_ORDER_NUMBER', responseValue)
      return response
    },
    async maxConsumptionNo({ commit }) {
      let response = await Api.request('get', '/inventoryOut/consumptionLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_CONSUMPTION_NUMBER', responseValue)
      return response
    },
    async maxDamageNo({ commit }) {
      let response = await Api.request('get', '/inventoryOut/damageLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_DAMAGE_NUMBER', responseValue)
      return response
    },

    async maxSalesInvoiceBillNo({ commit }) {
      let response = await Api.request('get', '/inventoryOut/salesInvoiceLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_SALES_INVOICE_NUMBER', responseValue)
      return response
    },
    async maxSalesChallanNo({ commit }) {
      let response = await Api.request('get', '/inventoryOut/salesChallanLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_SALES_CHALLAN_NUMBER', responseValue)
      return response
    },
    async maxPurchaseReturnNumber({ commit }) {
      let response = await Api.request('get', '/inventoryOut/purchaseReturnLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      let responseValue = response.data.data
      commit('MAX_PURCHASE_RETURN_NUMBER', responseValue)
      return response
    },
    async addSalesOrder({commit}, salesOrder) {
      let response = await Api.request('post', '/inventoryOut/saveSalesOrder/' + this.state.organisationid + '/' + this.getters.userId, salesOrder)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_ORDER', responseValue)
      }
      return response
    },
    async addConsumption({commit}, salesOrder) {
      let response = await Api.request('post', '/inventoryOut/saveConsumption/' + this.state.organisationid + '/' + this.getters.userId, salesOrder)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_ORDER', responseValue)
      }
      return response
    },
    async addDamage({commit}, salesOrder) {
      let response = await Api.request('post', '/inventoryOut/saveDamage/' + this.state.organisationid + '/' + this.getters.userId, salesOrder)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_ORDER', responseValue)
      }
      return response
    },
    async addSalesChallan({commit}, salesChallan) {
      let response = await Api.request('post', '/inventoryOut/saveSalesChallan/' + this.state.organisationid + '/' + this.getters.userId, salesChallan)
      // let responseValue = response.data.data
      // if (response.data.status === 'SUCCESS') {
      //   commit('ADD_SALES_CHALLAN', responseValue)
      // }
      return response
    },
    async addSalesInvoice({commit}, salesInvoice) {
      let response = await Api.request('post', '/inventoryOut/saveSalesInvoice/' + this.state.organisationid + '/' + this.getters.userId, salesInvoice)
      // let responseValue = response.data.data
      // if (response.data.status === 'SUCCESS') {
      //   commit('ADD_SALES_INVOICE', responseValue)
      // }
      return response
    },
    async addSalesDairyInvoice({commit}, salesInvoice) {
      let response = await Api.request('post', '/inventoryOut/saveSalesDairyInvoice/' + this.state.organisationid + '/' + this.getters.userId, salesInvoice)
      // let responseValue = response.data.data
      // if (response.data.status === 'SUCCESS') {
      //   commit('ADD_SALES_INVOICE', responseValue)
      // }
      return response
    },
    async addPurchaseReturn({commit}, purchaseReturn) {
      let response = await Api.request('post', '/inventoryOut/purchaseReturn/' + this.state.organisationid + '/' + this.getters.userId, purchaseReturn)
      // let responseValue = response.data.data
      // if (response.data.status === 'SUCCESS') {
      //   commit('ADD_PURCHASE_RETURN', responseValue)
      // }
      return response
    },
    async updateSalesReturn({commit}, salesReturn) {
      let response = await Api.request('put', '/inventoryOut/updateSales/' + salesReturn.inventoryOutHeaderId + '/' + this.getters.userId, salesReturn)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_SALES_RETURN', response.data.data)
      }
      return response
    },
    async loadSalesChallanLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/salesChallan/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('SALES_CHALLAN_LIST', responseValue)
      return response
    },
    async loadSalesOrderLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/salesOrder/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('SALES_ORDER_LIST', responseValue)
      return response
    },
    async loadConsumptionLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/consumption/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('CONSUMPTION_LIST', responseValue)
      return response
    },
    async loadPurchaseListForSales({ commit }, date) {
      let response = await Api.request('get', '/inventoryIn/purchaseAvailableDetailList/' + this.state.organisationid + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('PURCHASE_LIST_FOR_SALES', responseValue)
      return response
    },
    async loadDamageLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/damage/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('Damage_LIST', responseValue)
      return response
    },
    async loadSalesOrderCompletedLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/salesOrderCompleted/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('SALES_ORDER_COMPLETED_LIST', responseValue)
      return response
    },
    async loadSalesInvoiceLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/salesInvoice/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('SALES_INVOICE_LIST', responseValue)
      return response
    },
    async loadItemMarginReport({ commit }, date) {
      let url = `/inventoryAnalysis/itemMarginReport/${this.state.organisationid}/${date.fromDate}/${date.toDate}`
      if (date.itemIds && date.itemIds.length) {
        url += '?' + date.itemIds.map(id => `itemIds=${id}`).join('&')
      }
      let response = await Api.request('get', url)
      commit('PROFIT_GROSS', response.data.data)
      return response
    },
    async loadExpensesReport({ commit }, date) {
      let url = `/inventoryAnalysis/expenseReport/${this.state.organisationid}/${date.fromDate}/${date.toDate}`
      let response = await Api.request('get', url)
      commit('EXPENSES_REPORT', response.data.data)
      return response
    },
    async loadSalesInvoiceUnPaidLists({ commit }) {
      let response = await Api.request('get', '/inventoryOutReport/returnUnPaidInventoryOutHeader/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id)
      let responseValue = response.data.data
      commit('SALES_INVOICE_UNPAID_LIST', responseValue)
      return response
    },
    async loadsalesInvoiceChequeReceivedLists({ commit }) {
      let response = await Api.request('get', '/inventoryOutReport/returnChequeReceivedInventoryOutHeader/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id)
      let responseValue = response.data.data
      commit('SALES_INVOICE_CHEQUERECEIVED_LIST', responseValue)
      return response
    },
    async loadSalesInvoicePaidLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/returnPaidByDateInventoryOutHeader/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate)
      let responseValue = response.data.data
      commit('SALES_INVOICE_PAID_LIST', responseValue)
      return response
    },
    async loadSalesInvoiceUnPaidTodayLists({ commit }) {
      let response = await Api.request('get', '/inventoryOutReport/returnTodayUnPaidInventoryOutHeader/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id)
      let responseValue = response.data.data
      commit('SALES_INVOICE_TODAY_UNPAID_LIST', responseValue)
      return response
    },
    async loadSalesInvoiceUnReceivedLists({ commit }) {
      let response = await Api.request('get', '/inventoryOutReport/returnGoodsUnReceivedInventoryOutHeader/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id)
      let responseValue = response.data.data
      commit('SALES_INVOICE_UNRECEIVED_LIST', responseValue)
      return response
    },
    async loadSalesInvoiceUnReceivedAllLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/returnAllGoodsUnReceivedInventoryOutHeader/' + this.state.organisationid + '/' + this.state.fyId + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('SALES_INVOICE_UNRECEIVED_ALL_LIST', responseValue)
      return response
    },
    async loadSalesInvoiceUnpaidAndPaidAllLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/returnUnPaidAndPaidInventoryOutHeader/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('SALES_INVOICE_UNPAID_AND_PAID_ALL_LIST', responseValue)
      return response
    },
    async loadSalesInvoiceUnpaidNextFollowUp({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/returnUnPaidNextFollowUpInventoryOutHeader/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('SALES_INVOICE_UNPAID_NEXT_FOLLOWUP', responseValue)
      return response
    },
    async loadSalesPaymentTodaysFollowUp({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/returnTodaysPaymentFollowUp/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('SALES_PAYMENT_TODAYS_FOLLOWUP', responseValue)
      return response
    },
    async loadCustomerWiseSalesCountLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/customerWiseSalesCount/' + this.state.user.id + '/' + this.state.organisationid + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('CUSTOMER_WISE_SALES_COUNT_LIST', responseValue)
      return response
    },
    async loadSalesSummaryReportLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/customerTranscationSummary/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '')
      // let responseValue = response.data.data
      // commit('SALES_INVOICE_LIST', responseValue)
      return response
    },
    async loadpurchaseSummaryReportLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryInReport/supplierTranscationSummary/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '/' + date.fromDate + '/' + date.toDate + '')
      // let responseValue = response.data.data
      // commit('SALES_INVOICE_LIST', responseValue)
      return response
    },
    async loadSalesInvoiceVoidLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/salesInvoiceVoid/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('SALES_INVOICE_VOID_LIST', responseValue)
      return response
    },
    async deleteSalesOrder({commit}, deleteRea) {
      let response = await Api.request('delete', '/inventoryOut/deleteSales/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('DELETE_SALES_ORDER', deleteSales)
      return response
    },
    async deleteSalesChallan({commit}, deleteRea) {
      let response = await Api.request('delete', '/inventoryOut/deleteSales/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('DELETE_SALES_CHALLAN', deleteSales)
      return response
    },
    async deleteSalesInvoice({commit}, deleteRea) {
      let response = await Api.request('delete', '/inventoryOut/deleteSales/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('DELETE_SALES_INVOICE', deleteSales)
      return response
    },
    async deleteSalesReturn({commit}, deleteRea) {
      let response = await Api.request('delete', '/inventoryOut/deleteSales/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('DELETE_SALES_RETURN', deleteSales)
      return response
    },
    async updateSales({commit}, sales) {
      let resp = await Api.request('put', '/inventoryOut/updateSales/' + sales.inventoryOutheaderId + '/' + this.getters.userId, sales)
      commit('UPDATE_SALES', resp.data.data)
      return resp
    },
    async loadOutInventoryDetail({commit}, id) {
      let response = await Api.request('get', '/inventoryOutReport/inventoryOutDetail/' + this.getters.organisationId + '/' + this.getters.userId + '/' + id)
      if (response.data.status === 'SUCCESS') {
        commit('INVENTORY_OUT_DETAIL', response.data.data)
      }
      return response
    },
    async loadSalesReturnLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryInReport/salesReturn/' + this.state.organisationid + '/' + this.getters.userId + '/' + date.fromDate + '/' + date.toDate + '')
      let responseValue = response.data.data
      commit('SALES_RETURN_LIST', responseValue)
      return response
    },
    async updateSalesOrder({commit}, salesOrder) {
      let response = await Api.request('put', '/inventoryOut/updateSales/' + salesOrder.id + '/' + this.getters.userId, salesOrder)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_SALES_ORDER', response.data.data)
      }
      return response
    },
    async updateConsumption({commit}, salesOrder) {
      let response = await Api.request('put', '/inventoryOut/updateSales/' + salesOrder.id + '/' + this.getters.userId, salesOrder)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_CONSUMPTION', response.data.data)
      }
      return response
    },
    async updateDamage({commit}, salesOrder) {
      let response = await Api.request('put', '/inventoryOut/updateSales/' + salesOrder.id + '/' + this.getters.userId, salesOrder)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_DAMAGE', response.data.data)
      }
      return response
    },
    async updateSalesInvoice({commit}, sales) {
      let response = await Api.request('put', '/inventoryOut/updateSales/' + sales.id + '/' + this.getters.userId, sales)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_SALES_INVOICE', response.data.data)
      }
      return response
    },
    async updateSalesChallan({commit}, salesChallan) {
      let response = await Api.request('put', '/inventoryOut/updateSales/' + salesChallan.id + '/' + this.getters.userId, salesChallan)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_SALES_CHALLAN', response.data.data)
      }
      return response
    },
    async extraExpensesSalesList({commit}, inventoryHeaderId) {
      let response = await Api.request('get', '/inventoryOutReport/extraExpensesList/' + inventoryHeaderId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async salesBillNumber({commit}) {
      let response = await Api.request('get', '/inventoryOut/billNumber/' + this.getters.organisationId + '/' + this.state.fyId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async salesReturnBillWise({commit}, returnData) {
      let response = await Api.request('post', '/inventoryIn/salesReturnBillWise/' + returnData.inventoryHeaderId + '/' + this.getters.organisationId + '/' + this.getters.userId, returnData)
      // if (response.data.status === 'SUCCESS') {
      return response
      // }
    },
    async salesReturnDetailList({commit}, billNo) {
      let response = await Api.request('get', '/inventoryOutReport/salesDetailByBillNo/' + billNo + '/' + this.getters.organisationId + '/' + this.getters.userId + '/' + this.getters.fyId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async getCreditLimitAmount({commit}, accountId) {
      let response = await Api.request('get', '/inventoryOut/creditLimitAmount/' + accountId)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async updateStatusOfdOrder({commit}, data) {
      let response = await Api.request('put', '/inventoryOut/updateStatusOfdOrder/' + data.inventoryHeaderId + '/' + this.getters.userId + '/' + data.statusType + '/' + data.reason)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async updatePaidForVendor({commit}, data) {
      let response = await Api.request('put', '/delivery/updatePaidToVendor/' + data.idsForDelivery + '/' + this.getters.userId + '')
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async updateReturnedToVendor({commit}, data) {
      let response = await Api.request('put', '/delivery/updateReturnedToVendor/' + data.idsForDelivery + '/' + this.getters.userId + '')
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async addDelivery({commit}, salesOrder) {
      let response = await Api.request('post', '/delivery/saveOrderDetailsForDelivery/' + this.state.organisationid + '/' + this.getters.userId + '/' + this.state.fyId, salesOrder)
      // let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        // commit('ADD_SALES_ORDER', responseValue)
      }
      return response
    },
    // async maxDeliveryNo({ commit }) {
    //   let response = await Api.request('get', '/delivery/deliveryLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
    //   // let responseValue = response.data.data
    //   // commit('MAX_DELIVERY_NUMBER', responseValue)
    //   return response
    // },
    async loadDeliveryDetailsLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/allDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('DELIVERY_ORDER_LIST', responseValue)
      return response
    },
    async loadDeliveryToBeVerifyLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/initalDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('DELIVERY_TO_VERIFY_LIST', responseValue)
      return response
    },
    async updateStatusByAdmin({commit}, data) {
      let response = await Api.request('put', '/delivery/updateStatusByAdmin/' + data.inventoryHeaderId + '/' + data.statusType + '/' + data.reason + '/' + data.paymentStatus + '/' + data.assignedTo + '/' + data.deliveryCharge + '/' + data.billAmount + '/' + data.paymentMethod + '/' + this.state.user.id + '/' + data.customerName + '/' + data.address + '/' + data.primaryContact + '')
      if (response.data.status === 'SUCCESS') {
        commit('DELIVERY_STATUS_UPDATE', response.data.data)
        return response
      }
    },
    async loadDeliveredDetailsLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/allCompltedDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('DELIVERED_LIST', responseValue)
      return response
    },
    async loadCancelledDeliveryDetailsLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/cancelledDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('DELIVERED_LIST', responseValue)
      return response
    },
    async loadReturnedToVendorLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/returnedToVendorReport/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('DELIVERED_LIST', responseValue)
      return response
    },
    async loadRequestDeliveryLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/allRequestDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('DELIVERY_REQUEST_LIST', responseValue)
      return response
    },
    async loadVendorDeliveryLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/allDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '')
      let responseValue = response.data.data
      commit('VENDER_DELIVERY_LIST', responseValue)
      return response
    },
    async loadVendorPaidDeliveryLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/paidDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '/' + this.state.organisationid + '')
      let responseValue = response.data.data
      commit('VENDER_DELIVERY_PAID_LIST', responseValue)
      return response
    },
    async loadVendorUnPaidDeliveryLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/unPaidDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '/' + this.state.organisationid + '')
      let responseValue = response.data.data
      commit('VENDER_DELIVERY_UNPAID_LIST', responseValue)
      return response
    },
    async loadPendingDeliveryLists({ commit }, date) {
      let response = await Api.request('get', '/delivery/pendingDeliveryListByOrgId/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouse + '/' + this.state.organisationid + '')
      let responseValue = response.data.data
      commit('PENDING_DELIVERY_LIST', responseValue)
      return response
    },
    async loadDeliveryRemarksLogReport({ commit }, date) {
      let response = await Api.request('get', '/delivery/returnRemarksLogByDeliveryCode/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.deliveryCode + '')
      let responseValue = response.data.data
      commit('DELIVERY_REMARKS_LOG_LIST', responseValue)
      return response
    },
    async uploadExcelDeiveryDetails({commit}, item) {
      let response = await Api.request('post', '/fileUpload/excelFileUpload/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId, item, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      let savedItemMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('SALES_ORDER_LIST', savedItemMaster)
      }
      return response
    },
    async loadSalesOrderPendingLists({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/salesOrderPendingReport/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('SALES_DELIVERY_PENDING_LIST', responseValue)
      return response
    },
    async maxTransforNo({ commit }) {
      let response = await Api.request('get', '/stockTransfor/stockTransforLoadPage/' + this.state.organisationid + '/' + this.state.fyId)
      // let responseValue = response.data.data
      // commit('MAX_TRANSFOR_NUMBER', responseValue)
      return response
    },
    async addStockTransforInternal({commit}, stockTransfor) {
      let response = await Api.request('post', '/stockTransfor/stockTransforInternal/' + this.state.organisationid + '/' + this.getters.userId, stockTransfor)
      let responseValue = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_STOCK_TRANSFOR', responseValue)
      }
      return response
    },
    async updateStockTransforInternal({commit}, stockTransfor) {
      let response = await Api.request('put', '/stockTransfor/updateStockTransfor/' + stockTransfor.id + '/' + this.getters.userId, stockTransfor)
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_STOCK_TRANSFOR', response.data.data)
      }
      return response
    },
    async loadStockTransforInternalLists({ commit }, date) {
      let response = await Api.request('get', '/stockTransfor/stockTransforReport/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + this.state.warehouseData.id + '')
      let responseValue = response.data.data
      commit('STOCK_TRANSFOR_LIST', responseValue)
      return response
    },
    async loadStockTransforInternalStoreWiseLists({ commit }, date) {
      let response = await Api.request('get', '/stockTransfor/stockTransforReportStoreWise/' + this.state.organisationid + '/' + this.state.user.id + '/' + date.fromDate + '/' + date.toDate + '/' + date.warehouseFromId + '/' + date.warehouseToId + '')
      let responseValue = response.data.data
      commit('STOCK_TRANSFOR_LIST', responseValue)
      return response
    },
    async loadRidersLastLocation({ commit }) {
      let response = await Api.request('get', '/delivery/getRidersLastLocation/' + this.state.organisationid + '')
      let responseValue = response.data.data
      commit('SALES_ORDER_LIST', responseValue)
      return response
    },
    async loadSalesOrderIdList({commit}) {
      let response = await Api.request('get', '/inventoryOut/orderNumber/' + this.getters.organisationId + '/' + this.state.fyId)
      return response
    },
    async loadSalesChallanIdList({commit}) {
      let response = await Api.request('get', '/inventoryOut/challanNumber/' + this.getters.organisationId + '/' + this.state.fyId)
      return response
    },
    async loadDataWithSalesOrderId({commit}, orderId) {
      let response = await Api.request('get', '/inventoryOutReport/salesDetailByOrderNo/' + orderId + '/' + this.state.organisationid + '/' + this.state.user.id)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadDataWithSalesChallanNo({commit}, challanNo) {
      let response = await Api.request('get', '/inventoryOutReport/salesDetailByChallanNo/' + challanNo + '/' + this.state.organisationid + '/' + this.state.user.id)
      if (response.data.status === 'SUCCESS') {
        return response
      }
    },
    async loadStockTransforDetail({commit}, id) {
      let response = await Api.request('get', '/stockTransfor/stockTransforDetailsReport/' + this.getters.organisationId + '/' + this.getters.userId + '/' + id)
      if (response.data.status === 'SUCCESS') {
        commit('INVENTORY_OUT_DETAIL', response.data.data)
      }
      return response
    },
    async deleteStockTransfor({commit}, deleteRea) {
      let response = await Api.request('delete', '/stockTransfor/deleteStockTransfor/' + deleteRea.inventoryOutHeaderId + '/' + this.getters.userId + '/' + deleteRea.deleteReason)
      let deleteSales = response.data.data
      commit('DELETE_STOCK_TRANSFOR', deleteSales)
      return response
    },
    async loadLatestSalesRate({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/latestSaleRate/' + date.customerId + '/' + date.itemId + '')
      let responseValue = response.data.data
      commit('LATEST_SALES_RATE_LIST', responseValue)
      return response
    },
    async loadvariantDetailsList({ commit }, date) {
      let response = await Api.request('get', '/inventoryOutReport/variantDetailsListByInventoryInDetails/' + date.itemId + '')
      let responseValue = response.data.data
      commit('VARIANT_DETAILS_LIST', responseValue)
      return response
    },
    async createMonthlyTarget({commit}, accountMaster) {
      let response = await Api.request('post', '/inventoryOut/createSalesMonthlyTarget/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '', accountMaster)
      let savedAccountMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_MONTHLY_TARGET', savedAccountMaster)
      }
      return response
    },
    async deleteMonthlyTarget({ commit }, data) {
      let resp = await Api.request('delete', '/inventoryOut/deleteSalesMonthlyTarget/' + data.id + '/' + this.state.user.id + '/' + data.deleteReason)
      let deleteAccMasters = resp.data.data
      if (resp.data.status === 'SUCCESS') {
        commit('DELETE_MONTHLY_TARGET', deleteAccMasters)
      }
      return resp
    },
    async loadMonthlyTargetList({commit}) {
      let response = await Api.request('get', '/inventoryOut/listOfSalesMonthlyTargetByFyID/' + this.state.user.id + '/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_MONTHLY_TARGET_LIST', response.data.data)
      return response
    },
    async updateMonthlyTarget({ commit }, data) {
      let response = await Api.request(
        'put',
        `/inventoryOut/updateSalesMonthlyTarget/${this.state.user.id}/${data.id}/${this.state.organisationid}/${this.state.fyId}`,
        data
      )
      if (response.data.status === 'SUCCESS') {
        commit('UPDATE_MONTHLY_TARGET', response.data.data)
      }
      return response
    },
    async paymentSalesStatusUpdate({commit}, payment) {
      let response = await Api.request('put', '/inventoryOut/salesPaymentUpdateStatus/' + this.state.organisationid + '/' + payment.id + '/' + payment.status + '/' + payment.method + '/' + payment.creditDays)
      // if (response.data.status === 'SUCCESS') {
      //
      // }
      return response
    },
    async paymentSalesRemarksAndDate({ commit }, payment) {
      const params = new URLSearchParams()
      if (payment.chequeDate) {
        params.append('chequeDate', payment.chequeDate)
      }
      if (payment.followUpTime) {
        params.append('followTime', payment.followUpTime)
      }
      if (payment.followUpDate) {
        params.append('followUpDate', payment.followUpDate)
      }
      if (payment.chequeReceived) {
        params.append('chequeReceived', payment.chequeReceived)
      }
      if (payment.payedDate) {
        params.append('payedDate', payment.payedDate)
      }
      if (payment.paymentMethod) {
        params.append('paymentMethod', payment.paymentMethod)
      }
      if (payment.paymentStatus) {
        params.append('paymentStatus', payment.paymentStatus)
      }
      let url = `/inventoryOut/salesPaymentRemarksAndDate/${this.state.organisationid}/${payment.id}/${payment.remarks}`
      if (params.toString()) {
        url += '?' + params.toString()
      }
      let response = await Api.request('put', url)
      return response
    },
    async goodsReceivedStatusUpdate({commit}, payment) {
      let response = await Api.request('put', '/inventoryOut/salesGoodsUnreceivedStatus/' + this.state.organisationid + '/' + payment.id + '/' + payment.goodsReceivedStatus + '/' + payment.receivedRemarks)
      // if (response.data.status === 'SUCCESS') {
      //
      // }
      return response
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/sales.js